import React, { useMemo, useState } from 'react';

import { FirmCombobox } from '@/components/firms/FirmCombobox';
import { Button } from '@/components/ui/catalyst/button';

import { RunListTable } from '../../components/task-import-runs/RunListTable';
import { UploadRunDialog } from '../../components/task-import-runs/UploadRunDialog';
import { taskImportRunsApiClient } from '../../services/api/taskImportRunsService';

export const TaskImportRunsDashboard: React.FC = () => {
  const [firmFilter, setFirmFilter] = useState<string>('');
  const [showUpload, setShowUpload] = useState(false);

  const { data, isFetching } =
    taskImportRunsApiClient.useTaskImportRunsListQuery({
      firmId: firmFilter || undefined,
    });

  const runs = useMemo(() => data ?? [], [data]);

  return (
    <div className="p-4">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-xl font-semibold">External CMS Reconciliation</h1>
          <p className="text-sm text-gray-600">
            Upload an export from your CMS to compare with Finch.
          </p>
        </div>
        <div className="flex items-center gap-2 flex-nowrap">
          <FirmCombobox
            value={firmFilter}
            onChange={setFirmFilter}
            className="w-64 sm:w-72 md:w-80"
          />
          <Button
            color="blue"
            type="button"
            onClick={() => setShowUpload(true)}
            className="shrink-0"
          >
            New Import
          </Button>
        </div>
      </div>

      <RunListTable runs={runs} isLoading={isFetching} />

      {showUpload && (
        <UploadRunDialog
          isOpen={showUpload}
          onClose={() => setShowUpload(false)}
          defaultFirmId={firmFilter || undefined}
        />
      )}
    </div>
  );
};
